var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercentage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1544_37",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80556 4.05556C3.80274 4.05556 4.61111 3.37155 4.61111 2.52778C4.61111 1.68401 3.80274 1 2.80556 1C1.80837 1 1 1.68401 1 2.52778C1 3.37155 1.80837 4.05556 2.80556 4.05556Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1945 12C13.1917 12 14 11.316 14 10.4722C14 9.62844 13.1917 8.94443 12.1945 8.94443C11.1973 8.94443 10.3889 9.62844 10.3889 10.4722C10.3889 11.316 11.1973 12 12.1945 12Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1L1 12",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1544_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.16663 -0.833313H16.1667V13.8334H-1.16663V-0.833313Z",
    fill: "#5A5A5A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentage);
export default __webpack_public_path__ + "static/media/Percentage.3ed03e1a68f21a4d1a90334eda123a1b.svg";
export { ForwardRef as ReactComponent };